import "./ClienteTabs.css";
import { NavLink } from "react-router-dom";

export default function ClienteTabs() {
  return (
    <div className="cliente-tabs">
      <NavLink
        to="/dados"
        className={({ isActive }) =>
          isActive
            ? "cliente-tab ativo"
            : "cliente-tab"
        }
      >
        Dados
      </NavLink>

      <NavLink
        to="/pedidos"
        className={({ isActive }) =>
          isActive
            ? "cliente-tab ativo"
            : "cliente-tab"
        }
      >
        Pedidos
      </NavLink>
    </div>
  );
}